import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { InventoryEntryModel } from 'src/app/models/inventory/inventory-entry.model';
import { InventoryEntryPrintModel } from 'src/app/models/print/inventory/inventory-entry-print.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { InventoryEntryTableModel } from 'src/app/models/tables/inventory/inventory-entry-table.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class InventoryEntryService {

  constructor(private _httpClient: HttpClient) { }

  createInventoryEntry(inventoryEntryContract: InventoryEntryModel): Observable<InventoryEntryModel> {
    return this._httpClient.post<InventoryEntryModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryEntry.CreateInventoryEntry}`,
      inventoryEntryContract);
  }

  deleteInventoryEntry(inventoryEntryId: number): Observable<InventoryEntryModel> {
    return this._httpClient.delete<InventoryEntryModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryEntry.DeleteInventoryEntry}/${inventoryEntryId}`);
  }

  exportGeneralConsultation(filters: ColumnResponseModel[], columnSort: string | null, ascendant: boolean): Observable<Blob> {
    const params = new HttpParams()
      .set('columnSort', columnSort ?? '')
      .set('ascendant', ascendant.toString());

    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryEntry.ExportGeneralConsultation}`, filters, {
      params,
      responseType: 'blob',
    });
  }

  getAllConceptsForSelect(): Observable<any[]> {
    return this._httpClient.get<any[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryEntry.GetAllConceptsForSelectAsync}`,);
  }

  getAllInventoriesForSelect(): Observable<any[]> {
    return this._httpClient.get<any[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryEntry.GetAllInventoriesForSelectAsync}`,);
  }

  getAllInventoryEntryTypesForSelect(): Observable<any[]> {
    return this._httpClient.get<any[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryEntry.GetAllInventoryEntryTypesForSelectAsync}`,);
  }

  getColumnsForGeneralConsultation(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryEntry.GetColumnsForGeneralConsultationAsync}`);
  }

  getConceptByIdForSelect(conceptId: number): Observable<any> {
    return this._httpClient.get<any>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryEntry.GetConceptByIdForSelect}/${conceptId}`);

  }
  getEmptyPrintInventoryEntry(): Observable<InventoryEntryPrintModel> {
    return this._httpClient.get<InventoryEntryPrintModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryEntry.GetEmptyPrintInventoryEntry}`);
  }

  getFirstInventoryEntryByKeysAsync(inventoryId: number, branchId: number, inventoryEntryTypeId: number): Observable<InventoryEntryModel> {
    const params = new HttpParams().set('inventoryId', inventoryId)
      .set('branchId', branchId)
      .set('inventoryEntryTypeId', inventoryEntryTypeId);

    return this._httpClient.get<InventoryEntryModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryEntry.GetFirstInventoryEntryByKeysAsync}`,
      { params: params });
  }

  getInventoryByIdForSelect(inventoryId: number): Observable<any> {
    return this._httpClient.get<any>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryEntry.GetInventoryByIdForSelect}/${inventoryId}`);
  }

  getInventoryEntriesForGeneralConsultation(page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<InventoryEntryTableModel>> {
    const params = new HttpParams()
      .set('page', page)
      .set('limit', limit)
      .set('columnSort', columnSort || '')
      .set('ascendant', ascendant);

    return this._httpClient.post<PagedResponseModel<InventoryEntryTableModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryEntry.GetInventoryEntriesForGeneralConsultation}`,
      filters, { params: params }
    );
  }

  getInventoryEntryByKeysAsync(inventoryId: number, branchId: number, inventoryEntryTypeId: number, consecutive: number): Observable<InventoryEntryModel> {
    const params = new HttpParams()
      .set('inventoryId', inventoryId)
      .set('branchId', branchId)
      .set('inventoryEntryTypeId', inventoryEntryTypeId)
      .set('consecutive', consecutive);

    return this._httpClient.get<InventoryEntryModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryEntry.GetInventoryEntryByKeysAsync}`,
      { params: params }
    );
  }

  getInventoryEntryTypeByIdForSelect(inventoryEntryTypeId: number): Observable<any> {
    return this._httpClient.get<any>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryEntry.GetInventoryEntryTypeByIdForSelect}/${inventoryEntryTypeId}`);
  }

  getLastInventoryEntryByKeysAsync(inventoryId: number, branchId: number, inventoryEntryTypeId: number): Observable<InventoryEntryModel> {
    const params = new HttpParams().set('inventoryId', inventoryId)
      .set('branchId', branchId)
      .set('inventoryEntryTypeId', inventoryEntryTypeId);

    return this._httpClient.get<InventoryEntryModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryEntry.GetLastInventoryEntryByKeysAsync}`,
      { params: params });
  }

  getInventoryEntryById(inventoryEntryId: number): Observable<InventoryEntryModel> {
    return this._httpClient.get<InventoryEntryModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryEntry.GetInventoryEntryById}/${inventoryEntryId}`);
  }

  getNextInventoryEntryByKeysAsync(inventoryId: number, branchId: number, inventoryEntryTypeId: number, consecutive: number | null): Observable<InventoryEntryModel> {
    let params = new HttpParams().set('inventoryId', inventoryId)
      .set('branchId', branchId)
      .set('inventoryEntryTypeId', inventoryEntryTypeId)
    if (consecutive !== null)
      params = params.set('consecutive', consecutive.toString());

    return this._httpClient.get<InventoryEntryModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryEntry.GetNextInventoryEntryByKeysAsync}`,
      { params: params });
  }

  getPreviusInventoryEntryByKeysAsync(inventoryId: number, branchId: number, inventoryEntryTypeId: number, consecutive: number | null): Observable<InventoryEntryModel> {
    let params = new HttpParams().set('inventoryId', inventoryId)
      .set('branchId', branchId)
      .set('inventoryEntryTypeId', inventoryEntryTypeId)
    if (consecutive !== null)
      params = params.set('consecutive', consecutive.toString());
    return this._httpClient.get<InventoryEntryModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryEntry.GetPreviusInventoryEntryByKeysAsync}`,
      { params: params });
  }

  getPermissionPrint(): Observable<boolean> {
    return this._httpClient.get<boolean>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryEntry.GetPermissionPrint}`);
  }

  getPrintInventoryEntry(inventoryEntryId: number): Observable<InventoryEntryPrintModel> {
    return this._httpClient.get<InventoryEntryPrintModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryEntry.GetPrintInventoryEntry}/${inventoryEntryId}`);
  }
  getPrintInventoryEntryByFormat(branchId: number): Observable<InventoryEntryPrintModel> {
    return this._httpClient.get<InventoryEntryPrintModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryEntry.GetPrintInventoryEntryByFormat}/${branchId}`);
  }

  getPurchaseConcept(): Observable<number> {
    return this._httpClient.get<number>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryEntry.GetPurchaseConcept}`);
  }
  setStateInventoryEntry(inventoryEntryId: number): Observable<InventoryEntryModel> {
    return this._httpClient.put<InventoryEntryModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryEntry.SetStateInventoryEntry}/${inventoryEntryId}`,
      null);
  }

  updateInventoryEntry(inventoryEntryContract: InventoryEntryModel): Observable<InventoryEntryModel> {
    return this._httpClient.put<InventoryEntryModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryEntry.UpdateInventoryEntry}`,
      inventoryEntryContract);
  }
}
